import { Reveal, Overline } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-[#E4EFF8]/30 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14 md:mb-18">
          <Reveal className="lg:col-span-7">
            <Overline>Our Services</Overline>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.9rem] tracking-tight leading-[1.12] text-[#0B192C]">
              End-to-end trade &amp; logistics services
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="text-base text-[#475569] leading-relaxed max-w-md lg:ml-auto">
              Six core capabilities that carry your cargo from origin to destination — compliantly,
              efficiently and on time.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => (
            <Reveal key={service.key} delay={0.08 * (i % 3)} y={36}>
              <article
                data-testid={`service-card-${service.key}`}
                className="group h-full bg-white rounded-2xl overflow-hidden border border-[#E2E8F0]/80 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-22px_rgba(11,25,44,0.22)]"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.07]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/45 to-transparent" />
                  <span className="absolute top-4 left-4 rounded-full bg-[#FBF9F5]/90 backdrop-blur px-3.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#0B192C]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl text-[#0B192C] tracking-tight">
                    {service.title}
                  </h3>
                  <span className="mt-3 block h-[2px] w-10 bg-[#C5A059] transition-[width] duration-500 group-hover:w-20" />
                  <p className="mt-4 text-sm text-[#475569] leading-relaxed">{service.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
